import React from 'react';
import { useTranslation } from 'react-i18next';

import { contact } from '../../constant/contact';

function FooterContact() {
    const [t] = useTranslation('footer');

    return (
        <div>
            <p className={'mb-3 text-base font-bold uppercase tracking-wider text-white'}>{t('contact')}</p>

            <a
                className={'block text-base text-white hover:opacity-50'}
                href={`tel:${contact.PHONE.value}`}
            >
                {contact.PHONE.value}
            </a>

            <a
                className={'block text-base text-white hover:opacity-50'}
                href={`mailto:${contact.EMAIL.value}`}
            >
                {contact.EMAIL.value}
            </a>
        </div>
    );
}

export default FooterContact;
